import {
  BaseConversationUrgency,
  getUrgencyDisplay,
} from 'src/graphql/entities/conversation-urgency';
import { CONVERSATION_CARD_PROPERTY_KEYS } from 'src/graphql/entities/side-panel-personalization/model/card-keys';
import type { SidePanelPropertyDescriptor } from 'src/graphql/entities/side-panel-personalization/model/descriptors';
import { CreatedRow } from './created-row';
import {
  AssigneeRow,
  RequesterRow,
  StatusRow,
  TypeRow,
  UrgencyRow,
} from './form-property-rows';
import { LabelsRow } from './labels-row';
import { ParticipantsRow } from './participants-row';

const NORMAL_URGENCY_DISPLAY = getUrgencyDisplay(BaseConversationUrgency.Normal);

// card-rendered: the summary accordion consumes this key via useSectionVisibility.
// no Row ⇒ PersonalizedSections skips it (it is not a properties row)
export const SUMMARY_SECTION_PROPERTIES: SidePanelPropertyDescriptor[] = [
  {
    key: CONVERSATION_CARD_PROPERTY_KEYS.summary,
    label: 'Summary',
    defaultVisible: true,
    icon: 'sticky-note',
    iconLibrary: 'lucide',
    // pinned in the panel; also feeds leadingKeys so existing layouts prepend it
    reorderable: false,
  },
];

export const CONVERSATION_BASE_PROPERTIES: SidePanelPropertyDescriptor[] = [
  {
    key: 'base:status',
    label: 'Status',
    defaultVisible: true,
    Row: StatusRow,
    icon: 'circle-play',
    iconLibrary: 'lucide',
  },
  {
    key: 'base:assignee',
    label: 'Assignee',
    defaultVisible: true,
    Row: AssigneeRow,
    icon: 'users',
    iconLibrary: 'lucide',
  },
  {
    key: 'base:requester',
    label: 'Requester',
    defaultVisible: true,
    Row: RequesterRow,
    icon: 'user',
    iconLibrary: 'lucide',
  },
  {
    key: 'base:type',
    label: 'Type',
    defaultVisible: true,
    Row: TypeRow,
    icon: 'headphones',
    iconLibrary: 'lucide',
  },
  {
    key: 'base:urgency',
    label: 'Urgency',
    defaultVisible: true,
    Row: UrgencyRow,
    icon: NORMAL_URGENCY_DISPLAY.icon,
    iconLibrary: NORMAL_URGENCY_DISPLAY.library,
  },
  {
    key: 'base:created',
    label: 'Created',
    defaultVisible: true,
    Row: CreatedRow,
    icon: 'calendar',
    iconLibrary: 'lucide',
  },
  {
    key: 'base:labels',
    label: 'Labels',
    defaultVisible: true,
    Row: LabelsRow,
    icon: 'tags',
    iconLibrary: 'lucide',
  },
  {
    key: 'base:participants',
    label: 'Participants',
    defaultVisible: true,
    Row: ParticipantsRow,
    icon: 'users',
    iconLibrary: 'lucide',
  },
];
